const trackingUtils = require('od-modules/utils/tracking.utils');

let isFullScreenMap = false;

function hasDocumentFullScreen() {
    return Odigeo.Device.navigator.isIE
        ? document.msFullscreenElement !== null
        : !!(document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen || document.MSFullscreenChange);
}

function hasMapFullScreenChanged() {
    const hasChanged = isFullScreenMap !== hasDocumentFullScreen();
    isFullScreenMap = hasDocumentFullScreen();
    return hasChanged;
}

function trackFullScreenChange() {
    const label = `hotel_results_map_fullscreen_${hasDocumentFullScreen() ? 'open' : 'close'}`;
    const page = Odigeo.History.getPageNameFromFragment();
    trackingUtils.trackEvent('hotel_results_map', label, page);
}

module.exports = {
    hasMapFullScreenChanged,
    hasDocumentFullScreen,
    trackFullScreenChange,
};
